import { Badge } from '@mantine/core'
import type { Estado } from '@serkat/shared'
import { COLOR_ESTADO } from '../../tema/tema'

/** Los cuatro estados, siempre con el mismo color en todas las pestañas. */
export function EstadoBadge({ estado }: { estado: Estado }) {
  return (
    <Badge color={COLOR_ESTADO[estado]} variant="light" size="sm">
      {estado}
    </Badge>
  )
}
